import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 hover:border-primary-400/40 rounded-full transition-colors cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center text-primary-400">
                <i className={`${topic.icon} text-sm`}></i>
              </span>
              <span className="text-sm text-foreground-600 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}